<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1 *ngIf="!isAdded">{{'言語情報：編集' | translate}}</h1>
        <h1 *ngIf="!!isAdded">{{'言語情報：追加' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="addLanguage()" [disabled]="!languageFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span *ngIf="!isAdded">{{'更新' | translate}}</span>
          <span *ngIf="!!isAdded">{{'追加' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content>
    <form class="form" [formGroup]="languageFormGroup">
      <div class="dialog-body" fxLayout="row" fxLayoutGap="24px">

        <div class="dialog-left" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">{{'言語コード' | translate}}</mat-label>
            <input matInput *ngIf="!isAdded" placeholder="{{'言語コード' | translate}}" id="langCode"
              formControlName="langCode" readonly>
            <input matInput *ngIf="!!isAdded" placeholder="{{'言語コード' | translate}}" id="langCode"
              formControlName="langCode">
            <mat-error *ngIf="langCodeControl.invalid">{{ getErrorMessageToLangCode() }}</mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">{{'言語名称' | translate}}</mat-label>
            <input matInput placeholder="{{'言語名称' | translate}}" id="langName" formControlName="langName"
              value="{{ language!.lang_name }}">
            <mat-error *ngIf="langNameControl.invalid">{{ getErrorMessageToLangName() }}</mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="100%">
            <input matInput placeholder="{{'表示名称(英語モード用)' | translate}}" id="langNameEn"
              formControlName="langNameEn" value="{{ language!.lang_name_en }}">
            <mat-error *ngIf="langNameEnControl.invalid">{{ getErrorMessageToDisplayNameEn() }}</mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">{{'表示名称' | translate}}</mat-label>
            <input matInput placeholder="{{'表示名称' | translate}}" id="displayName" formControlName="displayName"
              value="{{ language!.display_name }}">
            <mat-error *ngIf="displayNameControl.invalid">{{ getErrorMessageToDisplayName() }}</mat-error>
          </mat-form-field>

          <div class="select-lang-file" fxFlex="100%">
            <div class="lang-file-title" fxLayout="row" fxLayoutAlign="space-between end">
              <span>{{'アイコン画像' | translate}}</span>
              <button mat-stroked-button (click)="openSelectLangFileDialog()">
                <mat-icon>add</mat-icon>
                <span>{{'アイコン選択' | translate}}</span>
              </button>
            </div>
            <table>
              <tr *ngIf="language!.lang_file != ''">
                <td><img [src]="language!.lang_file" height="70px" width="70px"></td>
                <td>
                  <button mat-stroked-button color="warn" (click)="deleteLangFile()">
                    <mat-icon>clear</mat-icon>
                  </button>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="dialog-right" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">{{'翻訳用言語コード' | translate}}</mat-label>
            <input matInput placeholder="{{'翻訳用言語コード' | translate}}" id="transLangCode" formControlName="transLangCode"
              value="{{ language!.trans_lang_code }}">
            <mat-error *ngIf="transLangCodeControl.invalid">{{ getErrorMessageToTransLangCode() }}</mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">{{'音声作成用言語コード' | translate}}</mat-label>
            <input matInput placeholder="{{'音声作成用言語コード' | translate}}" id="ttsLangCode" formControlName="ttsLangCode"
              value="{{ language!.tts_lang_code }}">
            <mat-error *ngIf="ttsLangCodeControl.invalid">{{ getErrorMessageToTtsLangCode() }}</mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">{{'男性音声コード' | translate}}</mat-label>
            <input matInput placeholder="{{'男性音声コード' | translate}}" id="ttsVoiceCodeM" formControlName="ttsVoiceCodeM"
              value="{{ language!.tts_voice_codes[0].code }}">
            <mat-error *ngIf="ttsVoiceCodeMControl.invalid">{{ getErrorMessageToTtsVoiceCodeM() }}</mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">{{'女性音声コード' | translate}}</mat-label>
            <input matInput placeholder="{{'女性音声コード' | translate}}" id="ttsVoiceCodeF" formControlName="ttsVoiceCodeF"
              value="{{ language!.tts_voice_codes[1].code }}">
            <mat-error *ngIf="ttsVoiceCodeFControl.invalid">{{ getErrorMessageToTtsVoiceCodeF() }}</mat-error>
          </mat-form-field>
        </div>
      </div>

    </form>
  </div>

</div>